export default {
  getShopPerformanceList: {
    url: '/performance/getShopPerformanceList',
    method: 'post',
    desc: '获取店铺表现数据'
  },
  getShopPerformanceExpandList: {
    url: '/performance/getShopPerformanceExpandList',
    method: 'post',
    desc: '获取店铺表现展开列表'
  },
  getShopPerformanceTotal: {
    url: '/performance/getShopPerformanceTotal',
    method: 'post',
    desc: '获取店铺表现总计'
  },
}
